import { api } from './api';

export const listBuildings = () => api.get('/api/buildings').then(r => r.data);
export const createBuilding = (payload) => api.post('/api/buildings', payload).then(r => r.data);
export const updateBuilding = (id, payload) => api.put(`/api/buildings/${id}`, payload).then(r => r.data);
export const deleteBuilding = (id) => api.delete(`/api/buildings/${id}`).then(r => r.data);
